const WORKSPACE_LOGIN_ORIGINS = new Set([
  'https://app.ganjutech.com',
  'https://app.chatplus.ai',
  'https://app-staging.chatplus.ai',
]);

// 与新版已接入的服务市场 / Jolect 授权回调路由保持一致。
const STORE_AUTH_CALLBACK_PATH =
  /^\/auth\/shop\/result\/(?:(?:lazada|tiktok|tiktok_us)\/enter|jolect)\/[^/]+$/;

export function isStoreAuthLogin(nextpage: string | undefined): boolean {
  return Boolean(nextpage && STORE_AUTH_CALLBACK_PATH.test(nextpage.split('?')[0]));
}

/** 账号版本和国内外节点由后端决定，只迁移新版已支持的授权上下文。 */
export function resolveLegacyStoreAuthRedirect(
  loginUrl: string,
  nextpage: string | undefined,
): string | undefined {
  if (!nextpage || !isStoreAuthLogin(nextpage)) {
    return undefined;
  }

  try {
    const login = new URL(loginUrl);
    if (!WORKSPACE_LOGIN_ORIGINS.has(login.origin) || login.pathname !== '/login') {
      return undefined;
    }
    const callback = new URL(nextpage, login.origin);
    if (
      callback.origin !== login.origin ||
      callback.hash ||
      !STORE_AUTH_CALLBACK_PATH.test(callback.pathname)
    ) {
      return undefined;
    }

    // 只透传授权页使用的渠道，不把 token 等登录参数带到新域名。
    const channel = callback.searchParams.get('channel');
    callback.search = '';
    if (channel) {
      callback.searchParams.set('channel', channel);
    }
    return callback.href;
  } catch {
    return undefined;
  }
}

/** 复用新版快捷登录，登录态只在新版落地，旧授权页不进入旧工作台。 */
export function resolveStoreAuthQuickLogin(
  loginUrl: string,
  nextpage: string | undefined,
  token: string,
): string {
  const callbackUrl = resolveLegacyStoreAuthRedirect(loginUrl, nextpage);
  if (!callbackUrl || !token) {
    throw new Error('Invalid workspace store authorization login response');
  }
  const callback = new URL(callbackUrl);
  callback.searchParams.set('token', token);
  return callback.href;
}
